import { useEffect } from 'react';
import { noteEdge } from '@/lib/companion/companion-activity';
import { onAnalyticsEvent } from '@/lib/analytics/capture';
import { ANALYTICS_EDGE } from '../utils/analytics-reactions';

/**
 * Feeds app activity into the companion's activity store.
 *
 * Product analytics already fires at the moments the product considers
 * meaningful, at the call sites that own them, so the companion reads that one
 * stream rather than subscribing to a bus per signal. Mounted once by
 * CompanionLayer; the subscription is torn down with it.
 *
 * Levels are not here: "a recording is in progress" is a state with a source
 * of truth, observed per beat by the engine, not a moment to be told about.
 */
export function useActivitySources(): void {
  useEffect(() => onAnalyticsEvent((name) => {
    const edge = ANALYTICS_EDGE[name];
    if (edge) noteEdge(edge);
  }), []);
}
